import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IWorkerData } from '../../initialState';

export interface IWorkerCreateRequestAction {
  data: {
    all_interventions: boolean;
    company_details: boolean;
    email: string;
    firstName?: string;
    intervention_partnership_id: number;
    invoice_permission: boolean;
    lastName?: string;
    locale: string;
    // teamId: number;
    userType?: string;
    user_management: boolean;
  };
  functions: {
    error: (err: any) => void;
    handleClose: () => void;
  };
}

function createRequest(
  draft: Draft<IWorkerData>,
  _: PayloadAction<IWorkerCreateRequestAction>,
) {
  draft.create.config.isLoading = true;
}

export default createRequest;
